import { gql } from 'react-apollo';

export default gql`
  mutation offerToggleFavorite($offerId: ID!, $favorited: Boolean!) {
    offerToggleFavorite(offerId: $offerId, favorited: $favorited) {
      _id
      investorOffer {
        _id
        hasAccessedWorkspace
        favorited
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/offerToggleFavorite.js